import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SedsBasicButtonComponent } from './seds-basic-button.component';
import { SedsCoreButtonModule } from '../../seds-buttons/seds-core-button/seds-core-button.module';

@NgModule({
  declarations: [SedsBasicButtonComponent],
  imports: [CommonModule, SedsCoreButtonModule],
  exports: [SedsBasicButtonComponent],
})
export class SedsBasicButtonModule {}
